import script from "./RecommendationWizardPage.vue?vue&type=script&lang=js"
export * from "./RecommendationWizardPage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__